import { make } from 'vuex-pathify';
import enrichColumns from './enrichColumns';
import makeTableCommonActions from './vuexTableCommonActionsMaker';
import makeTableCommonGetters from './vuexTableCommonGettersMaker';
import makeTableCommonState from './vuexTableCommonStateMaker';
export default function constructLocalEntity({ apiVersion, remoteEntityName, localEntity_operatingMode, fetchAllColumnsWhenFetching, repeatLastFetchOnContextOrgIdChange, repeatLastFetchOnContextScopeIntervalChange, defaultRecordCardComponent, defaultListComponent, createControllerName, fetchControllerName, updateControllerName, deleteControllerName, pageTitle, pageSubtitle, controlledActions, columns, genericTableDefaultProps, rowValidationRules, rowDragCompletionCallback, applyToRecordBeforeUpdate, columnsOverrides, additionalState, additionalGetters, additionalActions, additionalTableButtons, tableDatePickers, defaultRecordCreateComponent, 
// #region: entity specific
entityLabel, entityDescription, entityIcon, entityFieldPrefix, entityLabelPlural, entityExampleRecords, 
// #endregion
generationContexts, listUploadTemplateDownloadLink }) {
    // why state is set up as function => see section "Module reuse" of https://vuex.vuejs.org/guide/modules.html
    // because we want to be able to create instances of modules
    const state = () => (Object.assign(Object.assign({}, makeTableCommonState()), additionalState));
    const getters = Object.assign(Object.assign(Object.assign({}, makeTableCommonGetters({ remoteEntityName, localEntity_operatingMode, apiVersion, fetchAllColumnsWhenFetching, repeatLastFetchOnContextOrgIdChange, repeatLastFetchOnContextScopeIntervalChange, defaultRecordCardComponent, defaultListComponent, createControllerName, fetchControllerName, updateControllerName, deleteControllerName })), { pageTitle: () => pageTitle || '', pageSubtitle: () => pageSubtitle || '', controlledActions: () => {
            return controlledActions || {
                create: [0],
                fetch: [0],
                update: [0],
                delete: [0],
                downloadList: [0],
                uploadList: [0]
            };
        }, columns: () => { return []; }, genericTableDefaultProps: () => genericTableDefaultProps ? genericTableDefaultProps() : {}, rowValidationRules: (state, getters, rootState, rootGetters) => { return rowValidationRules ? rowValidationRules(state, getters, rootState, rootGetters) : []; }, rowDragCompletionCallback: () => rowDragCompletionCallback || (() => ({})), applyToRecordBeforeUpdate: () => applyToRecordBeforeUpdate || ((newVal, oldVal) => newVal), defaultRecordCardComponent: () => defaultRecordCardComponent, defaultListComponent: () => defaultListComponent, additionalTableButtons: () => additionalTableButtons || [], tableDatePickers: () => tableDatePickers || [], 
        //
        entityLabel: () => entityLabel, entityDescription: () => entityDescription, entityIcon: () => entityIcon, entityFieldPrefix: () => entityFieldPrefix, entityLabelPlural: () => entityLabelPlural, entityExampleRecords: () => entityExampleRecords, 
        //
        generationContexts: () => generationContexts || [], listUploadTemplateDownloadLink: () => listUploadTemplateDownloadLink }), additionalGetters);
    if (columns) {
        if (columnsOverrides) {
            getters.columns = (state, getters, rootState, rootGetters) => {
                const cols = columns(state, getters, rootState, rootGetters);
                let res = enrichColumns(cols);
                if (columnsOverrides.exclude)
                    res = res.filter(col => { var _a; return col.name && !((_a = columnsOverrides.exclude) === null || _a === void 0 ? void 0 : _a.includes(String(col.name))); });
                if (columnsOverrides.hideWhenDisplaying) {
                    for (const col of res) {
                        if (col.name && columnsOverrides.hideWhenDisplaying.includes(String(col.name)))
                            col.hideWhenDisplaying = true;
                    }
                }
                if (columnsOverrides.doNotHideWhenDisplaying) {
                    for (const col of res) {
                        if (col.name && columnsOverrides.doNotHideWhenDisplaying.includes(String(col.name)))
                            col.hideWhenDisplaying = false;
                    }
                }
                if (columnsOverrides.additionalColumns) {
                    // @ts-ignore
                    res = [...res, ...enrichColumns(columnsOverrides.additionalColumns, rootState)];
                }
                return res;
            };
        }
        else {
            getters.columns = (state, getters, rootState, rootGetters) => {
                const columns_ = columns(state, getters, rootState, rootGetters);
                return enrichColumns(columns_);
            };
        }
    }
    const mutations = make.mutations(state);
    const namespaced = true;
    const actions = Object.assign(Object.assign({}, makeTableCommonActions()), additionalActions);
    return { state, actions, mutations, getters, namespaced };
}
